import api from './api';

export const listRooms = (sectionId) =>
  api.get(`/sections/${sectionId}/rooms`).then(r => r.data);

export const getRoomDetail = (roomId) =>
  api.get(`/rooms/${roomId}`).then(r => r.data);

export const createRoom = (sectionId, data) =>
  api.post(`/sections/${sectionId}/rooms`, data).then(r => r.data);

export const updateRoom = (roomId, data) =>
  api.put(`/rooms/${roomId}`, data).then(r => r.data);

export const deleteRoom = (roomId) =>
  api.delete(`/rooms/${roomId}`).then(r => r.data);
